/**
 * Адреса блоков главной: короткий путь → id блока. Только данные, без
 * импортов — чтобы их могли читать и src/i18n/locale.ts, и src/lib/sections.ts
 * без циклической зависимости. Логика вокруг них — в sections.ts.
 */
export const SECTION_PATHS = {
  product: 'tracks',
  cases: 'cases',
  roi: 'calculator',
  method: 'methodology-stages',
  partners: 'partners',
  diagnostics: 'final-cta',
  reviews: 'reviews',
  why: 'why',
} as const

export type SectionSlug = keyof typeof SECTION_PATHS
